// extracted by mini-css-extract-plugin
module.exports = {"duplicateRoadmapPortal":"X2PdI5KP","modalContent":"zUIKzvTF","label":"_6Zu-X9EO","smallLabel":"p6pOP-AT"};